import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontal16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconStackHorizontal16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.389 3H2.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h.889a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5M2.5 2A1.5 1.5 0 0 0 1 3.5v9A1.5 1.5 0 0 0 2.5 14h.889a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5zm11 1h-.889a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h.889a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5m-.889-1a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5h.889a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 13.5 2zM7.556 3h.888a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-.888a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5m-1.5.5a1.5 1.5 0 0 1 1.5-1.5h.888a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-.888a1.5 1.5 0 0 1-1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontal16);
